import { render, staticRenderFns } from "./courseCharts.vue?vue&type=template&id=20fd8c0e&scoped=true&"
import script from "./courseCharts.vue?vue&type=script&lang=js&"
export * from "./courseCharts.vue?vue&type=script&lang=js&"
import style0 from "./courseCharts.vue?vue&type=style&index=0&id=20fd8c0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd8c0e",
  null
  
)

export default component.exports